@if ($UserComponent()) {
<ng-container *ngComponentOutlet="$UserComponent(); inputs: { contentlet: contentlet }" />
} @else {
<p>No matching component for: {{ contentlet?.contentType }}</p>
}
